<template>
    <modal :title="$t('user.add_user')" :visible.sync="isShowDialog" width="800px" :close-on-click-modal="false">
        <div class="wizard-container">
            <!-- 步骤条 -->
            <el-steps :active="activeStep" align-center finish-status="success" class="wizard-steps">
                <el-step :title="$t('account_redesign.wizard_step_basic')"></el-step>
                <el-step :title="$t('account_redesign.wizard_step_role')"></el-step>
                <el-step :title="$t('account_redesign.wizard_step_scope')"></el-step>
            </el-steps>

            <!-- Step 1: 基本信息 -->
            <div v-show="activeStep === 0" class="wizard-step-content">
                <el-form ref="basicForm" label-width="120px" :rules="basicRules" :model="dioForm" class="centered-form">
                    <!-- Company：仅平台企业显示下拉，非平台企业用当前用户 customerId（隐藏） -->
                    <el-form-item v-if="showCompanyField" :label="$t('account_redesign.company')" prop="customerId">
                        <el-select v-model="dioForm.customerId" style="width:300px" @change="changeCustomer" filterable>
                            <el-option v-for="item in customerArray" :key="item.id" :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('user.account')" prop="account">
                        <el-input v-model.trim="dioForm.account" style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('account_redesign.display_name')" prop="username">
                        <el-input v-model.trim="dioForm.username" style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('public.phone_num')" prop="mobile">
                        <el-input v-model.trim="dioForm.mobile" style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('public.email')" prop="email">
                        <el-input v-model.trim="dioForm.email" style="width: 300px"></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <!-- Step 2: 角色分配 -->
            <div v-show="activeStep === 1" class="wizard-step-content">
                <el-form ref="roleForm" label-width="120px" :rules="roleRules" :model="dioForm" class="centered-form">
                    <!-- 角色：必填，带刷新按钮 + 超链接 -->
                    <el-form-item :label="$t('account_redesign.role')" prop="roleId">
                        <div class="select-with-refresh">
                            <el-select v-model="dioForm.roleId" filterable style="width:300px" @change="onRoleChange">
                                <el-option v-for="item in roleArray" :key="item.id" :value="item.id" :label="item.name"></el-option>
                            </el-select>
                            <el-button circle icon="el-icon-refresh" size="mini" @click="refreshRoles" :loading="roleLoading"></el-button>
                        </div>
                        <div class="link-wrapper">
                            <router-link :to="{ path: '/account/role' }" target="_blank" class="add-link">{{ $t('account_redesign.no_role_add') }}</router-link>
                        </div>
                    </el-form-item>
                    <!-- Role 权限树 -->
                    <el-form-item v-if="roleResourceTree.length > 0" :label="$t('account_redesign.role_permission')">
                        <div class="treeClass" v-loading="roleTreeLoading">
                            <el-tree :key="$i18n.locale" :props="props" :data="roleResourceTree" :default-expand-all="true" node-key="id" :render-content="renderRoleTreeContent"></el-tree>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <!-- Step 3: 范围分配 -->
            <div v-show="activeStep === 2" class="wizard-step-content">
                <el-form ref="scopeForm" label-width="120px" :model="dioForm" class="centered-form">
                    <!-- 范围：仅非 V-mark 时显示 -->
                    <el-form-item v-if="!isVmark" :label="$t('account_redesign.scope')">
                        <div class="select-with-refresh">
                            <el-select v-model="dioForm.scopeId" filterable clearable style="width:300px" @change="onScopeChange">
                                <el-option v-for="item in scopeArray" :key="item.id" :value="item.id" :label="item.name"></el-option>
                            </el-select>
                            <el-button circle icon="el-icon-refresh" size="mini" @click="refreshScopes" :loading="scopeLoading"></el-button>
                        </div>
                        <div class="link-wrapper">
                            <router-link :to="{ path: '/account/scope' }" target="_blank" class="add-link">{{ $t('account_redesign.no_scope_add') }}</router-link>
                        </div>
                    </el-form-item>
                    <!-- 组织架构树 -->
                    <el-form-item v-if="showTree" :label="$t('account_redesign.organization')">
                        <div class="treeClass" v-loading="loadingTree">
                            <el-tree :props="props" :data="displayTree" :default-expand-all="true" node-key="scene_id"></el-tree>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('account_redesign.close') }}</el-button>
            <el-button type="primary" @click="prevStep" v-if="activeStep > 0">{{ $t('account_redesign.wizard_prev') }}</el-button>
            <el-button type="primary" @click="nextStep" v-if="activeStep < 2">{{ $t('account_redesign.wizard_next') }}</el-button>
            <el-button type="primary" @click="handleSave" v-if="activeStep === 2">{{ $t('public.btn_apply') }}</el-button>
        </div>

        <!-- 成功创建UAM账号浮动框 -->
        <modal
            :title="$t('account_redesign.success_create_title')"
            :visible.sync="showSuccessDialog"
            width="600px"
            :close-on-click-modal="false"
            append-to-body
        >
            <div class="success-dialog-body">
                <p class="success-body-text">{{ $t('account_redesign.success_create_body') }}</p>
                <p class="success-warning-text">{{ $t('account_redesign.success_create_warning') }}</p>
                <p class="success-choose-text">{{ $t('account_redesign.success_create_choose') }}</p>
                <p class="success-desc-text">{{ $t('account_redesign.success_create_csv_desc') }}</p>
                <p class="success-desc-text">{{ $t('account_redesign.success_create_show_desc') }}</p>
                <div v-if="passwordVisible" class="password-display">
                    <span class="password-label">{{ $t('account_redesign.csv_password') }}：</span>
                    <span class="password-value">{{ createdPassword }}</span>
                </div>
                <p class="success-security-text">{{ $t('account_redesign.success_create_security') }}</p>
                        <p class="success-warning-text">{{ $t('account_redesign.success_create_48h_warning') }}</p>
                    </div>
            <div slot="footer">
                <el-button type="primary" @click="downloadCsv">{{ $t('account_redesign.download_csv_file') }}</el-button>
                <el-button type="primary" @click="togglePassword">{{ passwordVisible ? $t('account_redesign.hide_password') : $t('account_redesign.show_password') }}</el-button>
                <el-button type="primary" @click="closeSuccessDialog">{{ $t('account_redesign.close') }}</el-button>
            </div>
        </modal>
    </modal>
</template>

<script>
import { accountCustomer, accountRole, accountStructure } from '@/api/modules/userInfo.js';
import { listScopes, createSubAccount } from '@/api/modules/account.js';
import { roleResource } from '@/api/modules/role.js';

export default {
    props: ['isShow', 'statusArray', 'roleTypeArray', 'activeUserType'],
    computed: {
        isShowDialog: {
            get() {
                return this.isShow;
            },
            set(val) {
                this.$emit('update:isShow', val);
            }
        },
        basicRules() {
            const rules = {
                account: [
                    { required: true, message: this.$t('validate.user_account_required'), trigger: 'blur' },
                    { max: 20, message: this.$t('validate.len_20'), trigger: 'blur' }
                ],
                username: [
                    { required: true, message: this.$t('validate.user_name_required'), trigger: 'blur' },
                    { max: 50, message: this.$t('validate.len_50'), trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: this.$t('validate.user_mobile_required'), trigger: 'blur' },
                    { max: 20, message: this.$t('validate.len_20'), trigger: 'blur' }
                ],
                email: [
                    { required: true, message: this.$t('validate.email_required'), trigger: 'blur' },
                    { max: 255, message: this.$t('validate.len_255'), trigger: 'blur' },
                    { type: 'email', message: this.$t('validate.email_format'), trigger: ['blur', 'change'] }
                ]
            };
            // 平台企业时 Company 必填
            if (this.showCompanyField) {
                rules.customerId = [{ required: true, message: this.$t('validate.user_company_required'), trigger: 'change' }];
            }
            return rules;
        },
        roleRules() {
            return {
                roleId: [{ required: true, message: this.$t('validate.user_role_required'), trigger: 'change' }]
            };
        },
        userCustomerId() {
            const userInfo = this.$store.getters.userInfo;
            if (!userInfo) return '';
            // 兼容 snake_case / camelCase，优先从 scope 取，fallback 到 user.default_customer_id
            const scope = userInfo.scope || {};
            const user = userInfo.user || {};
            return scope.customerId
                || user.defaultCustomerId || '';
        },
        showCompanyField() {
            return String(this.userCustomerId) === '1';
        },
        currentCompanyId() {
            if (this.showCompanyField) {
                return this.dioForm.customerId || '';
            }
            return String(this.userCustomerId);
        },
        isVmark() {
            return String(this.currentCompanyId) === '1';
        },
        calcRoleType() {
            return this.isVmark ? 2 : 0;
        },
        showTree() {
            return this.isVmark || (this.dioForm.scopeId !== '' && this.dioForm.scopeId != null);
        },
        displayTree() {
            if (this.isVmark) {
                return this.fullTree;
            }
            if (this.dioForm.scopeId) {
                const scope = this.scopeArray.find(s => s.id === this.dioForm.scopeId);
                if (scope && scope.sceneIds) {
                  return this.filterTreeByIds(scope.sceneTree, this.parseSceneIds(scope.sceneIds))
                }
            }
            return [];
        }
    },
    watch: {
        isShow(val) {
            if (val) {
                this.activeStep = 0;
                this.resetForm();
            }
        }
    },
    data() {
        return {
            activeStep: 0,
            dioForm: {
                username: '',
                account: '',
                mobile: '',
                email: '',
                status: 2,
                roleType: 0,
                customerId: '',
                roleId: '',
                scopeId: '',
                sceneIds: [],
                syncContact: 0,
                userType: '',
                initialPassword: ''
            },
            customerArray: [],
            roleArray: [],
            scopeArray: [],
            fullTree: [],
            roleLoading: false,
            scopeLoading: false,
            loadingTree: false,
            roleResourceTree: [],
            roleTreeLoading: false,
            props: {
                label: 'label',
                children: 'item'
            },
            // 成功创建浮动框
            showSuccessDialog: false,
            createdPassword: '',
            createdAccount: '',
            passwordVisible: false
        };
    },
    methods: {
        renderRoleTreeContent() {
            let createElement = arguments[0]
            let data = arguments[1].data
            let isZh = (this.$i18n.locale || '').indexOf('zh') === 0
            let displayName = isZh ? (data.nameZh || data.label) : (data.nameEn || data.label)
            return createElement('span', displayName)
        },
        resetForm() {
            this.dioForm = {
                username: '',
                account: '',
                mobile: '',
                email: '',
                status: 2,
                roleType: 0,
                // 平台企业默认选第一个（等 customer 列表加载后修正），非平台企业用当前用户 customerId
                customerId: this.showCompanyField ? '' : String(this.userCustomerId),
                roleId: '',
                scopeId: '',
                sceneIds: [],
                syncContact: 0,
                userType: this.activeUserType || 'ENTERPRISE',
                initialPassword: ''
            };
            this.customerArray = [];
            this.roleArray = [];
            this.scopeArray = [];
            this.fullTree = [];
            this.roleResourceTree = [];
            this.passwordVisible = false;
            this.createdPassword = '';
            this.createdAccount = '';
            // 平台企业时立即加载 customer 列表（Step 1 的 Company 下拉需要）
            if (this.showCompanyField) {
                this.loadCustomers();
            }
        },
        async nextStep() {
            try {
                if (this.activeStep === 0) {
                    await this.$refs.basicForm.validate();
                    this.activeStep = 1;
                    await this.initStep2();
                } else if (this.activeStep === 1) {
                    await this.$refs.roleForm.validate();
                    this.activeStep = 2;
                    await this.initStep3();
                }
            } catch (e) {
                // 校验失败
            }
        },
        prevStep() {
            if (this.activeStep > 0) this.activeStep--;
        },
        /** 加载 Customer 列表（平台企业用，Step 1 的 Company 下拉） */
        async loadCustomers() {
            try {
                // 获取 V-mark（type=2）+ 所有企业（type=0），合并为 Customer 表完整列表
                const [platRes, entRes] = await Promise.all([
                    accountCustomer({ type: 2 }),
                    accountCustomer({ type: 0 })
                ]);
                const platform = (platRes && platRes.result) || [];
                const enterprises = (entRes && entRes.result) || [];
                this.customerArray = [...platform, ...enterprises];
                // 默认选中第一个
                if (this.customerArray.length > 0 && !this.dioForm.customerId) {
                    this.dioForm.customerId = this.customerArray[0].id;
                }
            } catch (e) {
                console.error('fetch customers error:', e);
            }
        },
        /** Step 2 初始化：根据 Step 1 选的 company 加载 role */
        async initStep2() {
            this.dioForm.roleType = this.calcRoleType;
            await this.loadRoles();
        },
        async loadRoles() {
            this.roleLoading = true;
            try {
                const res = await accountRole({
                    type: this.calcRoleType,
                    customerId: this.currentCompanyId || null
                });
                this.roleArray = res.result || [];
            } catch (e) {
                console.error('fetch roles error:', e);
                this.roleArray = [];
            } finally {
                this.roleLoading = false;
            }
        },
        refreshRoles() {
            this.loadRoles();
        },
        changeCustomer() {
            this.dioForm.roleId = '';
            this.dioForm.scopeId = '';
            this.dioForm.roleType = this.calcRoleType;
            this.roleResourceTree = [];
            this.loadRoles();
        },
        /** Role 选择变化时加载权限树 */
        onRoleChange() {
            if (this.dioForm.roleId) {
                this.loadRoleResource();
            } else {
                this.roleResourceTree = [];
            }
        },
        async loadRoleResource() {
            this.roleTreeLoading = true;
            try {
                const res = await roleResource({
                    id: this.dioForm.roleId,
                    type: this.calcRoleType,
                    isEdit: 0
                });
                if (res && res.result) {
                    this.roleResourceTree = res.result.item || [];
                } else {
                    this.roleResourceTree = [];
                }
            } catch (e) {
                console.error('fetch role resource error:', e);
                this.roleResourceTree = [];
            } finally {
                this.roleTreeLoading = false;
            }
        },
        /** Step 3 初始化 */
        async initStep3() {
            if (this.isVmark) {
                await this.loadFullTree();
            } else {
                // 非平台企业：scope 自带 scene_tree，不需要单独 loadFullTree
                await this.loadScopes();
            }
        },
        async loadFullTree() {
            this.loadingTree = true;
            try {
                const res = await accountStructure({
                    type: this.calcRoleType,
                    isEdit: 0,
                    customerId: this.isVmark ? null : (this.currentCompanyId || null)
                });
                this.fullTree = (res && res.result && res.result.item) || [];
            } catch (e) {
                console.error('fetch tree error:', e);
                this.fullTree = [];
            } finally {
                this.loadingTree = false;
            }
        },
        async loadScopes() {
            this.scopeLoading = true;
            try {
                const res = await listScopes({
                    customerId: this.currentCompanyId

                });
                if (res && res.state && res.state.code === 200) {
                    this.scopeArray = res.result || [];
                }
            } catch (e) {
                console.error('fetch scopes error:', e);
                this.scopeArray = [];
            } finally {
                this.scopeLoading = false;
            }
        },
        refreshScopes() {
            this.loadScopes();
        },
        onScopeChange() {
            // 树通过 computed displayTree 自动更新
        },
        parseSceneIds(sceneIdsStr) {
            if (!sceneIdsStr) return [];
            return sceneIdsStr.split(',').map(s => parseInt(s.trim())).filter(n => !isNaN(n));
        },
        filterTreeByIds(nodes, ids) {
            const result = [];
            if (!nodes) return result;
            nodes.forEach(node => {
                const children = this.filterTreeByIds(node.item, ids);
                const isMatch = ids.includes(node.sceneId);
                if (isMatch || children.length > 0) {
                    result.push({ ...node, item: children });
                }
            });
            return result;
        },
        /** 生成随机安全密码（8-12位，含大写+小写+数字+特殊符号） */
        generateSecurePassword() {
            const upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
            const lower = 'abcdefghijkmnpqrstuvwxyz';
            const digits = '23456789';
            const special = '!@#$%^&*';
            const all = upper + lower + digits + special;
            let pwd = '';
            pwd += upper[Math.floor(Math.random() * upper.length)];
            pwd += lower[Math.floor(Math.random() * lower.length)];
            pwd += digits[Math.floor(Math.random() * digits.length)];
            pwd += special[Math.floor(Math.random() * special.length)];
            const remainingLen = 4 + Math.floor(Math.random() * 5); // 4-8 additional chars, total 8-12
            for (let i = 0; i < remainingLen; i++) {
                pwd += all[Math.floor(Math.random() * all.length)];
            }
            // Shuffle
            return pwd.split('').sort(() => Math.random() - 0.5).join('');
        },
        async handleSave() {
            try {
                this.dioForm.userType = this.activeUserType || 'ENTERPRISE';
                this.dioForm.roleType = this.calcRoleType;
                // 构造 CreateSubAccountBody 入参（后端从 token 注入 operatorId，前端无需传）
                const payload = {
                    username: this.dioForm.account,
                    email: this.dioForm.email,
                    mobile: this.dioForm.mobile,
                    displayName: this.dioForm.username,
                    roleId: this.dioForm.roleId,
                    scopeIds: this.dioForm.scopeId ? [this.dioForm.scopeId] : [],
                    expireHours: 48,
                    companyId: this.currentCompanyId
                };
                const res = await createSubAccount(payload);
                if (res && res.state && res.state.code === 200) {
                    this.isShowDialog = false;
                    this.$message.success(this.$t('user.user_new_code_200'));
                    // 密码由后端生成并返回（仅此一次明文）
                    const result = res.result || {};
                    this.createdPassword = result.initialPassword || '';
                    this.createdAccount = result.username || this.dioForm.account;
                    this.passwordVisible = false;
                    this.showSuccessDialog = true;
                    this.$parent.getListFn();
                } else if (res && res.state) {
                    this.$message.error(res.state.msg || 'create failed');
                }
            } catch (e) {
                console.error('WizardDialog save error:', e);
                if (e && e.response && e.response.data && e.response.data.state) {
                    this.$message.error(e.response.data.state.msg || 'create failed');
                }
            }
        },
        /** 下载 CSV 文件 */
        downloadCsv() {
            let loginUrl = window.location.origin + '/login';
            // 非 V-mark 企业账号：登录 URL 带 companyCode 参数，登录页自动填充
            if (!this.isVmark && this.dioForm.customerId) {
                const customer = this.customerArray.find(c => c.id === this.dioForm.customerId);
                if (customer && customer.code) {
                    loginUrl += '?companyCode=' + encodeURIComponent(customer.code);
                }
            }
            const header = `${this.$t('account_redesign.csv_username')},${this.$t('account_redesign.csv_password')},${this.$t('account_redesign.csv_login_url')}`;
            const row = `${this.createdAccount},${this.createdPassword},${loginUrl}`;
            const csvContent = header + '\n' + row;
            const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `uam_account_${this.createdAccount}.csv`;
            link.click();
            URL.revokeObjectURL(link.href);
        },
        /** 显示/隐藏密码 */
        togglePassword() {
            this.passwordVisible = !this.passwordVisible;
        },
        /** 关闭成功浮动框 */
        closeSuccessDialog() {
            this.showSuccessDialog = false;
            this.createdPassword = '';
            this.createdAccount = '';
            this.passwordVisible = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.wizard-container {
    min-height: 400px;
}
.wizard-steps {
    margin-bottom: 30px;
}
.wizard-step-content {
    min-height: 300px;
}
/* 表单横向居中 */
.centered-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    ::v-deep .el-form-item {
        width: 460px;
    }
}
.select-with-refresh {
    display: flex;
    align-items: center;
    gap: 8px;
    ::v-deep .el-select {
        flex-shrink: 0;
    }
}
/* 超链接右对齐到下拉框右边（与刷新按钮左边对齐） */
.link-wrapper {
    width: 300px;
    text-align: right;
    box-sizing: border-box;
}
.add-link {
    display: inline-block;
    margin-top: 4px;
    font-size: 12px;
    color: var(--primary-color);
    text-decoration: none;
    &:hover {
        text-decoration: underline;
    }
}
.treeClass {
    max-height: 300px;
    overflow: auto;
    border: 1px solid #e7e7e7;
    padding: 10px 0;
    box-sizing: border-box;
    width: 100%;
}
/* 成功创建浮动框 */
.success-dialog-body {
    line-height: 1.8;
    .success-body-text {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 12px;
    }
    .success-warning-text {
        color: #e6a23c;
        font-weight: bold;
        margin-bottom: 12px;
    }
    .success-choose-text {
        margin-bottom: 8px;
    }
    .success-desc-text {
        color: #606266;
        margin-bottom: 4px;
    }
    .password-display {
        margin: 16px 0;
        padding: 10px 16px;
        background: #f0f9eb;
        border: 1px solid #e1f3d8;
        border-radius: 4px;
        .password-label {
            font-weight: bold;
        }
        .password-value {
            font-family: monospace;
            font-size: 16px;
            color: var(--primary-color);
        }
    }
    .success-security-text {
        color: #909399;
        font-size: 13px;
        margin-top: 12px;
    }
}
</style>
